"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartTrialModal = void 0;
var react_1 = __importStar(require("react"));
var react_confetti_1 = __importDefault(require("react-confetti"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var Configuration_1 = require("@CommonFrontend/Styles/Configuration/Configuration");
var ModalComponent_1 = __importDefault(require("@CommonFrontend/Modal/ModalComponent"));
var styles = __importStar(require("./StartTrialModal.css"));
var features = [
    "Create interactive proposals with e-signatures & pricing",
    "Get notified when someone interacts with your proposal",
    "Track when a buyer loses interest with analytics",
    "Dynamically personalize proposals with CRM data",
];
var StartTrialModal = function (_a) {
    var onClose = _a.onClose;
    var _b = __read((0, react_1.useState)(true), 2), showConfetti = _b[0], setShowConfetti = _b[1];
    (0, react_1.useEffect)(function () {
        var timer = setTimeout(function () {
            setShowConfetti(false);
        }, 1000);
        return function () { return clearTimeout(timer); };
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ModalComponent_1.default, { containerClassName: styles.modalContainer, contentClassName: styles.modalContent, isEscapable: false },
            react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.overlayStackZIndex }, function () { return (react_1.default.createElement(kaleidoscope_1.Stack, null,
                react_1.default.createElement(kaleidoscope_1.RainbowBar, { isTopRounded: false }),
                react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "end", paddingRight: "s", paddingTop: "s" },
                    react_1.default.createElement(kaleidoscope_1.IconButton, { onClick: onClose, icon: react_1.default.createElement(icons_1.Close, null), isRound: true })),
                react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "center", paddingTop: "s" },
                    react_1.default.createElement("img", { src: "/Assets/icons/QwilrLogoLettering.svg", width: "128", height: "51", alt: "Qwilr Logo" })),
                react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center" },
                    react_1.default.createElement(kaleidoscope_1.Stack, { gap: "l", align: "center", padding: "xxl" },
                        react_1.default.createElement(kaleidoscope_1.Stack, { paddingLeft: "xxl", paddingRight: "xxl" },
                            react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, element: "p", level: "3" }, "Your 14 day trial with Qwilr has started!")),
                        react_1.default.createElement(kaleidoscope_1.Stack, { paddingTop: "l", paddingBottom: "l" },
                            react_1.default.createElement("ul", null, features.map(function (feature, i) { return (react_1.default.createElement("li", { key: "trial-feature-list-".concat(i) },
                                react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", padding: "xs" },
                                    react_1.default.createElement(icons_1.Tick, { color: "success", className: styles.checklistTick }),
                                    react_1.default.createElement(kaleidoscope_2.Text, { size: "s", strong: true }, feature)))); }))),
                        react_1.default.createElement(kaleidoscope_1.Stack, { padding: "s" },
                            react_1.default.createElement(kaleidoscope_2.Text, { size: "s" }, "When your trial ends, you can choose to sign up for one of Qwilr's paid plans: Business or Enterprise.")),
                        react_1.default.createElement("div", { className: styles.buttonContainer },
                            react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Primary, size: kaleidoscope_1.ButtonSize.Large, onClick: onClose, width: "full" }, "OK")))))); })),
        react_1.default.createElement("div", { className: styles.confettiContainer },
            react_1.default.createElement(react_confetti_1.default, { colors: ["#716BF1", "#0BDAC9", "#FFB961"], recycle: false, numberOfPieces: showConfetti ? 600 : 0, drawShape: function (ctx) {
                    ctx.beginPath();
                    ctx.rect(0, 0, 6, 12);
                    ctx.fill();
                } }))));
};
exports.StartTrialModal = StartTrialModal;
